import en from './en.json';
import ru from './ru.json';
import hy from './hy.json';

const modules = { en, ru, hy };

module.exports = modules;
